.ux-iws-teaser-video-search {
    display: block;
    position: relative;
    box-shadow: 0 0 22px transparentize($color-black, 0.92);

    &__video-wrapper {
        position: relative;
        width: 100%;
        padding-top: 56.25%;
        height: 0;
        position: relative;

        video {
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            min-height: 100%;
            top: 0;
            left: 0;
        }

        video::-webkit-media-controls-overlay-play-button {
            display: none !important;
        }

        video:focus {
            outline: none;
        }
    }

    &__video-overlay {
        position: absolute;
        opacity: 0;
        pointer-events: none;
        top: 0;
        height: 100%;
        width: 100%;
        right: 0;
        background-color: transparentize($special-dark-blue, 0.08);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        transition: opacity $animationSpeed-normal $animationEasing-easeInOut;

        .ux-button {
            width: 75%;
            max-width: 240px;
        }

        &--active {
            pointer-events: auto;
            opacity: 1;
        }

        .ux-button:not(.ux-button--green) {
            margin-bottom: 10px;
        }
    }

    .ux-button:not(.ux-button--green) {
        background-color: $color-white;
        margin-bottom: 5px;

        &:hover {
            background-color: $color-black;
        }
    }

    &__play-button {
        height: 80px;
        width: 80px;
        position: absolute;
        margin: auto;
        transform: translate(-50%, -50%);
        top: 48%;
        left: 50%;
        cursor: pointer;
        z-index: 1;
        border-radius: 40px;
        background-color: transparentize($color-black, 0.3);
        text-align: center;
        transition: all 500ms ease;

        @media only screen and (max-width: 768px) {
            width: 60px;
            height: 60px;
        }

        &:hover {
            background-color: transparentize($color-black, 0.2);
        }

        &--inactive {
            opacity: 0;
            pointer-events: none;
        }
    }

    &__play-icon {
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: calc(50% + 3px);
        font-size: 26px;
        color: $color-white;
    }

    &__info-wrapper {
        display: flex !important;
        max-width: 100%;
        width: 100%;
        flex-direction: row;
        padding: 25px 30px;

        &:hover .ux-button {
            background-color: $color-black;
        }

        &:hover .ux-button ux-icon {
            color: $color-white;
        }
    }

    &__title {
        margin: 5px 0 0;
    }

    &__cta {
        margin-left: 25px;
        align-self: flex-end;
    }
}

.ux-iws-teaser-video-search-grid {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 100%;
    justify-content: space-between;

    .ux-iws-teaser-video-search {
        width: 100%;
        margin-bottom: 30px;

        @media only screen and (min-width: 1024px) {
            width: calc(50% - 15px);
        }

        @media only screen and (min-width: 1440px) {
            width: calc(33.3333% - 20px);
        }
    }

    @media only screen and (min-width: 1440px) {
        justify-content: flex-start;

        .ux-iws-teaser-video-search:not(:nth-child(3n)) {
            margin-right: 30px;
        }
    }
}
